import {useCallback, useContext, useEffect, useState} from 'react';
import {fabric} from 'fabric';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {detectPinchGesture} from '~/CreateFabricInvitation/utils/detectPinchGesture';
import {FabricContext} from '~/common/fabric/context/FabricContext';

const MIN_IMAGE_SIZE = 0.1;
const MAX_IMAGE_SIZE = 2;

/* eslint-disable no-underscore-dangle */
export const ImageSize = () => {
  const {canvas, activeObjects} = useContext(FabricContext);
  const [value, setValue] = useState(1);

  useEffect(() => {
    let scale = 1;
    setTimeout(() => {
      if (activeObjects?.length) {
        if (Array.isArray(activeObjects) && activeObjects.length > 0) {
          const [uyoImg] = activeObjects;
          const originalScale = fabric.util.findScaleToCover(uyoImg, uyoImg._originalObject);
          if (uyoImg) {
            scale = (uyoImg.scaleX / originalScale).toFixed(1);
            if (scale) {
              setValue(scale);
            }
          }
        }
      }
    }, 250);

    const cleanup = detectPinchGesture((scaleFactor) => {
      // Set scale of image on pinch
      setValue(scaleFactor);
    }, scale);

    return cleanup;
  }, [activeObjects]);

  const setNewValue = useCallback(
    (val) => {
      setValue(val);

      let uyoImage;
      if (Array.isArray(activeObjects) && activeObjects.length > 0) {
        [uyoImage] = activeObjects;

        const scale = fabric.util.findScaleToCover(uyoImage, uyoImage._originalObject);
        const newScale = scale * Number(val);
        uyoImage.scale(newScale);

        canvas.requestRenderAll();
        canvas.fire('object:modified');
      }
    },
    [canvas, activeObjects]
  );

  return (
    <div className="textsize">
      <Range
        min={MIN_IMAGE_SIZE}
        max={MAX_IMAGE_SIZE}
        step="0.1"
        value={value}
        onChange={setNewValue}
        onLocalChange={setNewValue}
        hasControls
        hiddenInput
      />
    </div>
  );
};
